import React from 'react'
import styles from './styles.module.scss'
import { useCustomer } from '@/src/context/customer/customer-context'

interface Props {
    isModalOpen: boolean
    onClick(): void
    isOrderActive: boolean
    canShowDot: boolean
}

export default function BurgerIcon(props: Props) {
    const { customerLoginStatus } = useCustomer()
    return (
        <div onClick={props.onClick} className={`${styles.container} ${props.isModalOpen && styles.burgerOpened}`} data-testid="menu">
            {
                (customerLoginStatus === 'loggedIn' && props.isOrderActive && props.canShowDot) &&
                <div className={styles.dot}>
                    <div className={styles.internalDot} />
                </div>
            }
            <div className={styles.l1} />
            <div className={styles.l2} />
            <div className={styles.l3} />
        </div>
    )
}
